    (function($) {

    //******************************************************************************
    //* Eye Catcher
    //******************************************************************************
    nd_eye_catcher = {
        init: function() {
            $stickyWrapper = $(".nd-header-eye-catcher-sticky-wrapper");
            if($stickyWrapper.length > 0) {
                $(".nd-header-eye-catcher-wrapper .close-button").on('click', this._hide_eye_catcher);
                $(".nd-header-eye-catcher-side-bar-element").on('click', this._open_eye_catcher);

                $observer = new IntersectionObserver(
                    function (entries, observer) {
                        if(entries[0].isIntersecting) {
                            this._show_eye_catcher();
                            observer.unobserve($(".nd-header-eye-catcher-wrapper")[0]);
                        }
                    }.bind(this),
                    {
                        root: null,
                        rootMargin: '0px',
                        threshold: 1.0
                    }
                );
                $observer.observe($(".nd-header-eye-catcher-wrapper")[0]);
            }
        },

        _open_eye_catcher: function () {
            // if sticky eye catcher out of viewport scroll down before showing it
            $elBottom = $(".nd-header-eye-catcher-sticky-wrapper").offset().top + $(".nd-header-eye-catcher-wrapper").outerHeight(true);
            $scrollBottom = $(window).scrollTop() + $(window).height();
            if($elBottom > $scrollBottom) {
                $('html, body').animate({
                    scrollTop: ($elBottom - $(window).height())
                }, 100, nd_eye_catcher._show_eye_catcher);
            } else {
                nd_eye_catcher._show_eye_catcher();
            }
        },

        _show_eye_catcher: function () {
            // Show circle element
            $(".nd-header-eye-catcher-wrapper").removeClass("animate__backOutRight").addClass('animate__backInRight animate__bounceIn');
            // Hide side-bar-element
            $(".nd-header-eye-catcher-side-bar-element").removeClass("animate__fadeIn show").addClass('animate__fadeOut');
        },

        _hide_eye_catcher: function (event) {
            event.preventDefault();
            // Hide circle element
            $(".nd-header-eye-catcher-wrapper").removeClass('animate__backInRight animate__bounceIn animate__delay-1s').addClass('animate__backOutRight');
            // Show side-bar-element
            $(".nd-header-eye-catcher-side-bar-element").removeClass('animate__fadeOut').addClass('animate__fadeIn show');
        },
    };
    
    })(jQuery);